import { useMemo } from 'react';

import settings from 'src/settings';
import type { ImagePaths, MediaConfig } from 'src/types/customizing';
import { apiPaths } from 'src/services/api/apiPaths';

type UseCustomMedia = Omit<MediaConfig, 'imageAvailable'> & ImagePaths;

/**
 * Returns the media setting from the media config. The config is stored in the window object because it
 * will be fetched from the backend via a script tag before the react-app initializes.
 */
const useCustomMedia = (): UseCustomMedia => {
  const { imageAvailable, ...mediaConfig } = useMemo(
    () => window.mediaConfig || {},
    [window.mediaConfig],
  );

  return useMemo(() => {
    if (!imageAvailable) return {};

    return {
      corporateLogoPath: imageAvailable.corporateLogo
        ? `${settings.VITE_APP_API_URL}${apiPaths.CUSTOMIZING.IMAGES.CORPORATE_LOGO}`
        : undefined,
      headerLogoPath: imageAvailable.headerLogo
        ? `${settings.VITE_APP_API_URL}${apiPaths.CUSTOMIZING.IMAGES.HEADER_LOGO}`
        : undefined,
      toolLogoPath: imageAvailable.toolLogo
        ? `${settings.VITE_APP_API_URL}${apiPaths.CUSTOMIZING.IMAGES.TOOL_LOGO}`
        : undefined,
      ...mediaConfig,
    };
  }, [imageAvailable, mediaConfig]);
};

export default useCustomMedia;
